// src/components/Footer.jsx
import { Link } from "react-router-dom";
import { FaTwitch, FaDiscord, FaInstagram, FaTiktok, FaYoutube, FaTwitter } from "react-icons/fa";
import Logo from "../assets/logo/pvalorlogo.png";

function Footer() {
  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Roster", path: "/roster" },
    { name: "Creators", path: "/creators" },
    { name: "Announcements", path: "/announcements" },
    { name: "Events", path: "/events" },
  ];

  const resourceLinks = [
    { name: "Matches", path: "/matches" },
    { name: "Shop", path: "/shop" },
    { name: "Contact", path: "/contact" },
    { name: "Join the Team", path: "/join" },
  ];

  const socialLinks = [
    { icon: FaDiscord, url: "https://discord.gg/SGXXCMpCxf", label: "Discord", color: "hover:text-indigo-400" },
    { icon: FaTwitch, url: "https://www.twitch.tv/primevaloresports", label: "Twitch", color: "hover:text-purple-400" },
    { icon: FaTiktok, url: "https://www.tiktok.com/@primevaloresports", label: "TikTok", color: "hover:text-pink-400" },
    { icon: FaInstagram, url: "https://www.instagram.com/primevaloresports/", label: "Instagram", color: "hover:text-pink-500" },
    { icon: FaYoutube, url: "https://youtube.com/@primevaloresports", label: "YouTube", color: "hover:text-red-500" },
    { icon: FaTwitter, url: "https://twitter.com/primevaloresports", label: "Twitter", color: "hover:text-blue-400" },
  ];

  return (
    <footer className="bg-gray-950 text-white">
      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center space-x-3 mb-6">
              <img src={Logo} alt="Prime Valor Logo" className="h-10 w-auto" />
              <span className="text-xl font-black tracking-tight uppercase">
                Prime <span className="text-red-600">Valor</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Elevating Caribbean gaming, one match at a time. Representing the region on the global stage.
            </p>
            {/* Social Icons */}
            <div className="flex flex-wrap gap-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className={`p-2 bg-gray-900 rounded-lg text-gray-400 ${social.color} transition-colors`}
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-4">
              Quick Links
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-red-500 transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-4">
              Resources
            </h3>
            <ul className="space-y-3">
              {resourceLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-red-500 transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-4">
              Get in Touch
            </h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:primevalorgaming@gmail.com"
                  className="text-gray-400 hover:text-red-500 transition-colors text-sm"
                >
                  primevalorgaming@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="https://discord.gg/SGXXCMpCxf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-red-500 transition-colors text-sm"
                >
                  Join our Discord
                </a>
              </li>
            </ul>

            {/* Newsletter CTA */}
            <div className="mt-6">
              <a
                href="https://discord.gg/SGXXCMpCxf"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold uppercase tracking-wide rounded transition-colors"
              >
                <FaDiscord />
                Join Discord
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-6xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © {new Date().getFullYear()} Prime Valor. All rights reserved.
            </p>
            <p className="text-sm text-gray-500">
              Website by{" "}
              <a
                href="https://romaintomlinson.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-red-500 hover:text-red-400 transition-colors"
              >
                CodeWithRomi
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
